export default function log(variable) {
    if (process.env.NODE_ENV === 'development') {
        console.log(variable);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/debug.js